import { UPDATE_BOOKMARK } from "../actions/actionTypes";

const initialState = {
    updateBookmark : 0
}

const updateBookmark = (state = initialState , action) =>{
    switch(action.type){
        case UPDATE_BOOKMARK : 
            return {
                ...state,
                ...{
                    updateBookmark : state.updateBookmark + 1
                }


            }

        default: return state;
    }

   
}

export default updateBookmark;